const checkIfSameDay = (start: string, end: string) => {
  const startDatetime = new Date(start);
  const endDatetime = new Date(end);
  const isSameDay =
    startDatetime.getDate() === endDatetime.getDate() &&
    startDatetime.getMonth() === endDatetime.getMonth() &&
    startDatetime.getFullYear() === endDatetime.getFullYear();

  return {
    start: startDatetime,
    end: endDatetime,
    isSameDay,
  } as const;
};

export const formatDateLong = (date: string, locale?: string) => {
  return new Date(date).toLocaleDateString(locale ?? "de-DE", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
};

export const getFormatedDatetimeSpan = (
  starts_at: string,
  ends_at: string,
  locale?: string,
) => {
  const { start, end, isSameDay } = checkIfSameDay(starts_at, ends_at);

  const startDate = start.toLocaleDateString(locale, {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const startTime = start.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });
  const endDate = end.toLocaleDateString(locale, {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const endTime = end.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });

  if (isSameDay) {
    return `${startDate}, ${startTime} - ${endTime} Uhr`;
  }

  return `${startDate}, ${startTime} Uhr - ${endDate}, ${endTime} Uhr`;
};

export const calculateFormatedDuration = (
  starts_at: string,
  ends_at: string,
) => {
  const { start, end, isSameDay } = checkIfSameDay(starts_at, ends_at);
  const diffInTime = end.getTime() - start.getTime();

  if (isSameDay) {
    const diffInHours = Math.ceil(diffInTime / (1000 * 60 * 60));
    return `${diffInHours} Stunden`;
  }

  const diffInDays = Math.ceil(diffInTime / (1000 * 60 * 60 * 24));
  return `${diffInDays} Tage`;
};
